<template>

  <div>

    <Send-Test-Email-Modal ref="SendTestEmailModal"/>
<!--
  To Do:
  - Add to translations file
  - connect to db
  - drop in instructions for handling {{ tags }}
  - Can we add in dummy data for fake guest name / rooms so they can see how it looks?
 - link in email test handling - use the email handler
-->

<div>
  <!-- This is the local navigation header -->
  <b-card title="Card Title" no-body style="margin-top: 0px; border-bottom: 0px;">
    <b-card-header header-tag="nav">
      <b-nav card-header tabs>
        <b-nav-item active>System Emails</b-nav-item>
      </b-nav>
    </b-card-header>


    <!-- This is for setting hotel confirmation email text -->
    <b-card-body class="text-center">
        <div>
          <b-card bg-variant="light">
            <b-form-group
              label-cols-lg="3"
              label="Confirmation Email"
              label-size="lg"
              label-class="font-weight-bold pt-0"
              class="mb-0"
            >
              <b-form-group
                label-cols-sm="3"
                label="Subject:"
                label-align-sm="right"
                label-for="subject"
                description="This is the subject line guests will see for this email."
              >
                <b-form-input id="subject"
                  :placeholder="`Your booking confirmation with ${this.getVendor.name}`"
                >
                </b-form-input>
              </b-form-group>

              <b-form-group
                label-cols-sm="3"
                label="Reply-To:"
                label-align-sm="right"
                label-for="replyto"
                description="If guests reply to this email, their email will be sent here. This email is set on Information page."
              >
                <b-form-input id="replyto"
                  :placeholder="`${this.getVendor.email}`"
                  disabled
                  ></b-form-input>
              </b-form-group>

              <b-form-group
                label-cols-sm="3"
                label="Body:"
                label-align-sm="right"
                label-for="body"
                description="Here will be a quick guide for how to use the {{}} tags thoughout the email template maybe we link out to another dedicated page with further descriptions and details for more help Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
              >
                <b-form-textarea id="body"
                  type="text"
                  rows="6"
                  placeholder="Enter the email text with appropriate tags here"
                  >
                </b-form-textarea>
              </b-form-group>

            </b-form-group>
            <b-button
              type="submit"
              variant="secondary"
              v-b-tooltip.hover.top= "'This will send a test email VENDOREMAIL'"
              @click="triggerEmailTestModal"
              >
              Send Test Email
            </b-button>
              <b-button
                type="submit"
                variant="success"
                v-b-tooltip.hover.top= "'Save Changes'"
                style="float: right"
                >Save</b-button>
          </b-card>
        </div>


  <!-- This is for setting hotel check-out/payment email text -->
       <div>
          <b-card bg-variant="light">
            <b-form-group
              label-cols-lg="3"
              label="Invoice Email"
              label-size="lg"
              label-class="font-weight-bold pt-0"
              class="mb-0"
            >
              <b-form-group
                label-cols-sm="3"
                label="Email Subject:"
                label-align-sm="right"
                label-for="nested-street"
                description="This is the subject line the guest will see when an email comes to them, we recommend using VENDORNAMETAG to display your hotel name in the subject line"
              >
                <b-form-input id="nested-street"
                  placeholder="Your booking confirmation with VendorName"
                >
                </b-form-input>
              </b-form-group>
              <b-form-group
                label-cols-sm="3"
                label="Email Reply-To:"
                label-align-sm="right"
                label-for="nested-city"
                description="This email is set in the Hotel Information page. This email will be used when a guest click 'reply-to'."
              >
                <b-form-input id="nested-city"
                  placeholder="vendor@vendoremail.com"
                  disabled
                  ></b-form-input>
              </b-form-group>
              <b-form-group
                label-cols-sm="3"
                label="Email Body:"
                label-align-sm="right"
                label-for="nested-city"
                description="Here will be a quick guide for how to use the {{}} tags thoughout the email template maybe we link out to another dedicated page with further descriptions and details for more help Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
              >
                <b-form-textarea id="nested-city"
                  type="text"
                  rows="6"
                  placeholder="Enter the email text with appropriate tags here"
                  >
                </b-form-textarea>
              </b-form-group>
            </b-form-group>
            <b-button
              type="submit"
              variant="secondary"
              v-b-tooltip.hover.top= "'This will send a test email VENDOREMAIL'"
              >Send Test Email</b-button>
              <b-button
                type="submit"
                variant="success"
                v-b-tooltip.hover.top= "'Save Changes'"
                style="float: right"
                >Save</b-button>
          </b-card>
        </div>

      </b-card-body>
    </b-card>
  </div>

  </div>
</template>


<script>
import { mapGetters } from 'vuex';
  export default {
    name: "general",
    components: {
      SendTestEmailModal: () => import('@/components/modals/SendTestEmailModal'),
    },
    data() {
      return {
        confirmationSubject: '',
        confirmationReplyTo: '',
        confirmationBody: ''
      };
    },
    methods: {
      triggerEmailTestModal() {
        this.$refs.SendTestEmailModal.open();
      }
    },
    computed: {
      ...mapGetters([
        'getVendor'
      ])
    },
  };
</script>

<style>
/* this is for the nav tabs */
.card-header {
  padding-bottom: 0px;
}
.nav-link {
  border-bottom: 0px;
}
</style>
